"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableActions = exports.Table = void 0;
var table_1 = require("./table");
exports.Table = table_1.default;
var tableActions_1 = require("./tableActions");
exports.TableActions = tableActions_1.default;
